import React, { useState } from 'react';
import './Gallery.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import imgOne from '../../assets/servicePage/gallery/1.png';
import imgTwo from '../../assets/servicePage/gallery/2.png';
import imgThree from '../../assets/servicePage/gallery/3.png';
import imgFour from '../../assets/servicePage/gallery/4.png';
import imgFive from '../../assets/servicePage/gallery/5.png';
import imgSix from '../../assets/servicePage/gallery/6.png';

const Gallery = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    
    const galleryImages = [
        { src: imgOne, alt: "TRUECARE Dental Center - Modern Treatment Room" },
        { src: imgTwo, alt: "TRUECARE Dental Center - Advanced Equipment" },
        { src: imgThree, alt: "TRUECARE Dental Center - Comfortable Waiting Area" },
        { src: imgFour, alt: "TRUECARE Dental Center - Sterile Environment" },
        { src: imgFive, alt: "TRUECARE Dental Center - Professional Setup" },
        { src: imgSix, alt: "TRUECARE Dental Center - Patient Care Area" }
    ];

    const openModal = (image) => {
        setSelectedImage(image);
    };

    const closeModal = () => {
        setSelectedImage(null);
    };

    return (
        <section className='gallery-section pt-100 pb-70'>
            <div className="container">
                <SectionTitle 
                    subTitle="Gallery"
                    title="🏥 TRUECARE Dental Center Gallery"
                    description="Explore our modern dental facility, advanced equipment, and comfortable treatment areas designed to provide you with the best dental care experience in Yamunanagar."
                />
                <div className="row">
                    <div className="col-md-5 col-sm-6">
                        <div className="gallery-img" onClick={() => openModal(galleryImages[0])}>
                            <img src={imgOne} alt="gallery" />
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <div className="gallery-img" onClick={() => openModal(galleryImages[1])}>
                            <img src={imgTwo} alt="gallery" />
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                        <div className="gallery-img" onClick={() => openModal(galleryImages[2])}>
                            <img src={imgThree} alt="gallery" />
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <div className="gallery-img" onClick={() => openModal(galleryImages[3])}>
                            <img src={imgFour} alt="gallery" />
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                        <div className="gallery-img" onClick={() => openModal(galleryImages[4])}>
                            <img src={imgFive} alt="gallery" />
                        </div>
                    </div>
                    <div className="col-md-5 col-sm-6">
                        <div className="gallery-img" onClick={() => openModal(galleryImages[5])}>
                            <img src={imgSix} alt="gallery" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal */}
            {selectedImage && (
                <div className="gallery-modal" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-btn" onClick={closeModal}>×</button>
                        <img src={selectedImage.src} alt={selectedImage.alt} />
                        <p className="modal-caption">{selectedImage.alt}</p>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Gallery;